import classNames from "classnames";
import { Localizer } from "infrastructure/localization/localizer";

type KompetenceGodkendtInfoProps = {
    godkendtAtDisplayString: string;
    godkendtAf?: string;
    godkendtAfRolleTitel?: string;
    godkendtAfAutorisationId?: string;
    showGodkenderAsBadge?: boolean;
    isSmall?: boolean;
    isBold?: boolean;
}

export const KompetenceGodkendtInfo = (props: KompetenceGodkendtInfoProps) => {
    const fontSize = props.isSmall ? 12 : 14;

    const godkendtAfInformation = [
        props.godkendtAf,
        props.godkendtAfAutorisationId && `, ${props.godkendtAfAutorisationId}`,
        props.godkendtAfRolleTitel && ` (${props.godkendtAfRolleTitel})`
    ];

    const godkendtAfDisplayText = godkendtAfInformation.filter(Boolean).join("");

    return (
        <div
            className="flex-row flex-container-row wrap align-items-center">
            <div className={classNames("margin-right-xs d-flex", props.isBold && "font-weight-bold")} style={{ fontSize: fontSize }}>
                {`${Localizer.global_godkendtDen(props.godkendtAtDisplayString)} ${Localizer.global_by().toLowerCase()}:`}
            </div>
            {props.showGodkenderAsBadge &&
              <span className="badge badge-pill badge-default padding-xs margin-right-s"> {godkendtAfDisplayText}</span>
            }
            {!props.showGodkenderAsBadge &&
              <span>{godkendtAfDisplayText}</span>
            }
        </div>
    );
}